import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Steps() {
  return (
    <section className="hire-ios-app-developers-steps p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="text-center">
              <h2>
                Hiring iOS App{" "}
                <span>
                  Developers <br className="d-md-block d-none" />
                  Made Simple!
                </span>
              </h2>
            </div>
          </Col>
        </Row>
        <div className="steps-wrap">
          <div className="num-image d-md-block d-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="299"
              height="636"
              fill="none"
              viewBox="0 0 299 636"
            >
              <g clipPath="url(#clip0_8756_3957)">
                <path
                  fill="#314252"
                  d="M139.702 252.08a65.676 65.676 0 01-112.11-46.438 65.665 65.665 0 0140.54-60.67 65.685 65.685 0 0171.57 14.232l19.5-19.504a93.255 93.255 0 00-101.631-20.216A93.251 93.251 0 000 205.636a93.245 93.245 0 0057.57 86.153 93.266 93.266 0 00101.632-20.216l-19.5-19.493z"
                ></path>
                <path
                  fill="#EE4657"
                  d="M139.702 476.807A65.675 65.675 0 0127.59 430.372a65.664 65.664 0 0140.541-60.671 65.68 65.68 0 0171.571 14.235l19.5-19.504a93.262 93.262 0 00-143.485 14.129 93.245 93.245 0 0041.854 137.961 93.266 93.266 0 00101.631-20.217l-19.5-19.498z"
                ></path>
                <path
                  fill="#F47A1F"
                  d="M159.201 364.422a65.671 65.671 0 0071.571 14.235 65.678 65.678 0 0040.541-60.671 65.666 65.666 0 00-40.541-60.67 65.682 65.682 0 00-71.571 14.235l-19.506-19.499a93.268 93.268 0 01101.632-20.216 93.249 93.249 0 010 172.306 93.265 93.265 0 01-101.632-20.216l19.506-19.504z"
                ></path>
                <path
                  fill="#F1B31C"
                  d="M271.547 608.692a93.301 93.301 0 01-107.499 17.567l-4.879-37.071a65.678 65.678 0 00101.045-9.952 65.669 65.669 0 00-67.418-100.891 65.678 65.678 0 00-33.627 17.972l-19.505-19.499a93.262 93.262 0 01131.436.448 93.249 93.249 0 01.447 131.426z"
                ></path>
                <path
                  fill="#29BECD"
                  d="M271.681 159.203a93.246 93.246 0 01-65.942 27.313 93.26 93.26 0 01-65.941-27.313l19.499-19.504a65.672 65.672 0 0059.25 17.976 65.675 65.675 0 0047.865-39.273 65.672 65.672 0 00-6.065-61.615 65.671 65.671 0 00-54.603-29.19h-66.091L130.023.012h75.732a93.259 93.259 0 0186.157 57.57 93.239 93.239 0 01-20.231 101.622z"
                ></path>
                <path
                  fill="#314252"
                  d="M143.212 205.642a49.942 49.942 0 01-30.829 46.144 49.95 49.95 0 01-54.432-10.823 49.94 49.94 0 017.566-76.841 49.948 49.948 0 0177.695 41.52z"
                ></path>
                <path
                  fill="#29BECD"
                  d="M205.659 143.198a49.948 49.948 0 0046.148-30.827 49.939 49.939 0 00-36.4-68.097 49.948 49.948 0 00-59.688 48.988 49.942 49.942 0 0049.94 49.936z"
                ></path>
                <path
                  fill="#EE4657"
                  d="M143.193 430.369a49.935 49.935 0 01-59.683 48.977 49.937 49.937 0 01-18.002-90.498 49.943 49.943 0 0177.685 41.521z"
                ></path>
                <path
                  fill="#F47A1F"
                  d="M205.644 367.926a49.944 49.944 0 0035.322-85.256 49.952 49.952 0 00-54.433-10.825 49.938 49.938 0 00-16.201 81.453 49.948 49.948 0 0035.312 14.628z"
                ></path>
                <path
                  fill="#F1B31C"
                  d="M205.604 592.692a49.95 49.95 0 0046.148-30.827 49.933 49.933 0 00-10.824-54.428 49.942 49.942 0 00-76.846 7.566 49.934 49.934 0 00-8.418 27.747 49.937 49.937 0 0049.94 49.942z"
                ></path>
                <path
                  fill="#fff"
                  d="M205.852 93.048c0 13.181-5.312 22.226-16.194 22.226-11.015 0-15.867-9.896-15.931-21.964 0-12.304 5.242-22.093 16.258-22.093 11.411 0 15.867 10.164 15.867 21.83zm-22.095.262c-.064 9.773 2.295 14.443 6.163 14.443 3.868 0 5.965-4.852 5.965-14.556 0-9.441-2.033-14.443-6.029-14.443-3.675.005-6.163 4.66-6.099 14.556zM223.496 80.786h-.134l-8.131 3.873-1.637-7.489 11.277-5.242h8.26v42.613h-9.629l-.006-33.755zM92.212 205.449c0 13.175-5.308 22.221-16.194 22.221-11.016 0-15.868-9.896-15.932-21.965 0-12.303 5.243-22.093 16.258-22.093 11.411 0 15.868 10.164 15.868 21.837zm-22.095.256c-.064 9.774 2.295 14.444 6.163 14.444 3.868 0 5.965-4.852 5.965-14.556 0-9.442-2.033-14.443-6.03-14.443-3.675.005-6.162 4.659-6.098 14.555zM97.133 226.953v-6.034l5.51-4.98c9.309-8.329 13.835-13.117 13.963-18.097 0-3.477-2.097-6.232-7.013-6.232-3.676 0-6.886 1.84-9.095 3.541l-2.82-7.147c3.21-2.423 8.196-4.392 13.969-4.392 9.63 0 14.947 5.639 14.947 13.374 0 7.141-5.178 12.838-11.341 18.354l-3.938 3.279v.128h16.05v8.201l-30.232.005zM206.1 317.791c0 13.176-5.313 22.227-16.194 22.227-11.015 0-15.873-9.902-15.937-21.965 0-12.303 5.248-22.098 16.263-22.098 11.406 0 15.868 10.164 15.868 21.836zm-22.1.262c-.065 9.768 2.295 14.444 6.168 14.444s5.965-4.852 5.965-14.556c0-9.442-2.033-14.443-6.035-14.443-3.67 0-6.163 4.654-6.098 14.582v-.027zM212.791 329.528c1.765.915 5.831 2.622 9.897 2.622 5.178 0 7.805-2.493 7.805-5.703 0-4.199-4.199-6.098-8.592-6.098h-4.065v-7.147h3.867c3.344-.064 7.608-1.311 7.608-4.916 0-2.557-2.097-4.461-6.297-4.461-3.472 0-7.147 1.508-8.913 2.557l-2.033-7.211c2.558-1.643 7.672-3.21 13.177-3.21 9.095 0 14.166 4.788 14.166 10.624 0 4.525-2.557 8.061-7.805 9.902v.128c5.114.92 9.244 4.814 9.244 10.362 0 7.537-6.623 13.047-17.44 13.047-5.51 0-10.165-1.444-12.652-3.017l2.033-7.479zM90.756 430.177c0 13.176-5.313 22.227-16.194 22.227-11.015 0-15.867-9.902-15.937-21.965 0-12.303 5.248-22.098 16.263-22.098 11.412 0 15.868 10.164 15.868 21.836zm-22.095.262c-.07 9.768 2.295 14.444 6.163 14.444 3.868 0 5.965-4.852 5.965-14.556 0-9.442-2.033-14.444-6.034-14.444-3.67 0-6.163 4.654-6.094 14.535v.021zM113.322 451.681v-10.164H94.437v-6.489l16.13-25.966h12.198v24.982h5.114v7.489h-5.114v10.164l-9.443-.016zm0-17.653v-9.442c0-2.557.129-5.178.327-7.933h-.262c-1.381 2.755-2.494 5.243-3.938 7.933l-5.703 9.308v.134h9.576zM188.256 520.727c-11.016 0-16.264 9.768-16.264 22.093.07 12.062 4.922 21.964 15.937 21.964 10.882 0 16.194-9.051 16.194-22.227 0-11.672-4.456-21.83-15.867-21.83zm-.065 36.515c-3.868 0-6.232-4.654-6.163-14.444-.069-9.902 2.424-14.556 6.094-14.556 4.001 0 6.034 4.986 6.034 14.444 0 9.698-2.097 14.556-5.965 14.556zM234.025 539.148c-3.011-2.14-7.147-3.081-11.234-3.081a18.714 18.714 0 00-2.75.128l.915-6.558h16.525v-8.196h-23.475l-2.819 22.361a36.805 36.805 0 015.773-.396c8.522 0 11.999 2.675 11.999 7.083 0 4.525-4.392 6.488-8.527 6.488a24.42 24.42 0 01-9.63-2.097l-1.771 7.49c2.36 1.246 6.687 2.428 11.866 2.428 11.475 0 18.296-7.018 18.296-14.978.011-4.97-1.952-8.511-5.168-10.672z"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_8756_3957">
                  <path fill="#fff" d="M0 0H299V636H0z"></path>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="content content-one content-right">
            <div className="num num-one d-md-none d-inline-block">
              <span>01</span>
            </div>
            <h3>Share Your Needs</h3>
            <p>Describe your project and requirements.</p>
          </div>
          <div className="content content-two content-left">
            <div className="num num-two d-md-none d-inline-block">
              <span>02</span>
            </div>
            <h3>Select Pre-Vetted Talent</h3>
            <p>Review a list of qualified candidates.</p>
          </div>
          <div className="content content-three content-right">
            <div className="num num-three d-md-none d-inline-block">
              <span>03</span>
            </div>
            <h3>Schedule Interviews</h3>
            <p>Interview and assess selected developers.</p>
          </div>
          <div className="content content-four content-left">
            <div className="num num-four d-md-none d-inline-block">
              <span>04</span>
            </div>
            <h3>Start a Free Trial</h3>
            <p>Begin with a no-risk trial period.</p>
          </div>
          <div className="content content-five content-right">
            <div className="num num-five d-md-none d-inline-block">
              <span>05</span>
            </div>
            <h3>Hire with Confidence</h3>
            <p>Onboard your chosen iOS developer.</p>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Steps;
